<tp-modal dialogTitle="Add admin" [isBusy]="isSubmitting$ | async">
  <p>Select user to add as admin to the team '{{ this.data.team.name }}'</p>
  <br/>
  <tp-form [formGroup]="form" [isSubmitting$]="isSubmitting$" (doSubmit)="submit()">
    <mat-form-field>
      <mat-label>User</mat-label>
      <input type="text" matInput [formControl]="form.controls.user" [matAutocomplete]="auto">
      <mat-autocomplete #auto=matAutocomplete [displayWith]="displayUser">
        @for (user of members$ | async; track user) {
          <mat-option [value]="user">{{ user.email }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <div class="admonitionblock attention">
      <div class="icon">
        <i class="fa-solid fa-triangle-exclamation"></i>
      </div>
      <p>Granting a user admin permissions will give them full access to the team, including any clusters with in it.</p>
      <br/>
      <p>Exercise caution when making a user an administrator.</p>
    </div>
    <tp-form-actions
      [submitDisabled]="submitDisabled"
      [cancellable]="true" submitText="Add admin" [isSubmitting]="isSubmitting$ | async"
      buttonIdPrefix="teamAddAdminDialog" (cancel)="close()"
    />
  </tp-form>
</tp-modal>
